import { Spin, Form } from 'antd';
import { useState } from 'react';
import { ForumTopicPost } from '../../../../models/forumTopicPost';
import { createForumTopicPost } from '../../../../service/forumTopicPost';
import { createErrorNotification, createSuccessNotification } from '../../../../service/notification';
import Button from '../../../../components/Button/Button';
import FormItem from '../../../../components/FormItem/FormItem';
import TextArea from 'antd/lib/input/TextArea';
import styles from './AddPost.module.scss';

type Props = Pick< ForumTopicPost, 'clubId' | 'userId' | 'forumId' | 'forumTopicId'> 
& {
  refetchData: () => void
};

export const AddPost = ({ clubId, forumId, forumTopicId, userId, refetchData }: Props) => {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (payload) => {
    if(loading) return;

    setLoading(true);

    const {error, success} = await createForumTopicPost({
      post: payload.post
    }, clubId, forumId, forumTopicId, userId);

    setLoading(false);
      
    if(error) return createErrorNotification(error);
    createSuccessNotification('Tópico de discussão do fórum criado!');

    refetchData();
  }


  return(
    <div>
      <Form 
        layout="vertical" 
        form={form}
        onFinish={onFinish}
        id="formLogin" 
        className={styles.form}
      >
        <FormItem
          name="post"
          rules={[
            {
              required: true,
              message: 'Escreva sua postagem no tópico do fórum...',
            }
          ]}
          required
        >
          <TextArea className={styles.input} placeholder="Nova postagem..." />
        </FormItem>
        <Spin spinning={loading}>
          <Button submit style={styles.button}>Postar</Button>
        </Spin>
      </Form>
    </div>    
  );
}
